import {Cell, Pie, PieChart, ResponsiveContainer, Tooltip} from 'recharts';
import {PAYMENT_COLORS, formatCurrency} from '../utils';

import ChartTooltip from './ChartTooltip';
import {FC} from 'react';
import {PaymentMethodBreakdown} from 'store/models/dashboard';
import styles from '../Dashboard.module.scss';

interface Props {
  breakdown?: PaymentMethodBreakdown;
}

const PaymentMethodsChart: FC<Props> = ({breakdown}) => {
  const data = [
    {name: 'Cash', value: breakdown?.cash ?? 0},
    {name: 'Cards', value: breakdown?.cards ?? 0},
    {name: 'Other', value: breakdown?.other ?? 0},
  ];
  const total = data.reduce((sum, item) => sum + item.value, 0);

  return (
    <div className={styles.chartCard}>
      <div className={styles.chartHeader}>
        <h3>Payment Methods</h3>
        <span className={styles.chartSubtitle}>Cash flow distribution</span>
      </div>

      {total === 0 ? (
        <div className={styles.emptyState}>No data for selected period</div>
      ) : (
        <>
          <div className={styles.donutWrap}>
            <ResponsiveContainer width="100%" height={240}>
              <PieChart>
                <Pie
                  data={data}
                  dataKey="value"
                  nameKey="name"
                  cx="50%"
                  cy="50%"
                  innerRadius={68}
                  outerRadius={100}
                  paddingAngle={2}
                  cornerRadius={6}
                  stroke="none"
                >
                  {data.map((entry, index) => (
                    <Cell
                      key={entry.name}
                      fill={PAYMENT_COLORS[index % PAYMENT_COLORS.length]}
                    />
                  ))}
                </Pie>
                <Tooltip
                  content={<ChartTooltip />}
                  wrapperStyle={{outline: 'none'}}
                />
              </PieChart>
            </ResponsiveContainer>
            <div className={styles.donutCenter}>
              <span>Total</span>
              <strong>{formatCurrency(total)}</strong>
            </div>
          </div>

          <ul className={styles.legend}>
            {data.map((entry, index) => (
              <li key={entry.name} className={styles.legendItem}>
                <span
                  className={styles.legendDot}
                  style={{
                    background: PAYMENT_COLORS[index % PAYMENT_COLORS.length],
                  }}
                />
                <span className={styles.legendName}>{entry.name}</span>
                <span className={styles.legendValue}>
                  {formatCurrency(entry.value)}
                </span>
                <span className={styles.legendPct}>
                  {total ? Math.round((entry.value / total) * 100) : 0}%
                </span>
              </li>
            ))}
          </ul>
        </>
      )}
    </div>
  );
};

export default PaymentMethodsChart;
